'use es6';

import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIInputStaticLabel from 'UIComponents/input/UIInputStaticLabel';
import UITimePicker from 'UIComponents/input/UITimePicker';
import { useControlsContext } from '../context';
import { getEventValue } from '../../../utils/jsEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const ShareScheduleTimePickerSelect = () => {
  const {
    shareScheduleAtHour,
    setShareScheduleAtHour
  } = useControlsContext();
  const getTimezone = () => I18n.moment.portalTz().format('z');
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.scheduleTimeLabel"
    }),
    help: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.emailScheduleWarningText"
    }),
    required: true,
    children: /*#__PURE__*/_jsx(UIInputStaticLabel, {
      text: getTimezone(),
      position: "end",
      children: /*#__PURE__*/_jsx(UITimePicker, {
        clearable: false,
        interval: 60,
        onChange: e => {
          setShareScheduleAtHour(getEventValue(e) / 60);
        },
        value: shareScheduleAtHour * 60
      })
    })
  });
};
export default ShareScheduleTimePickerSelect;